import { SlotClientModel } from "./slot-client-model";

export const slotModel = new SlotClientModel();
